<template>
  <billing-layout>
    <div class="page-breadcrumb">
        <div class="row">
            <div class="col-5 align-self-center">
            </div>
            <div class="col-7 align-self-center">
                <div class="d-flex align-items-center justify-content-end">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                               <!-- <a href="#"  class="btn btn-success"><i class="fas fa-plus"></i> Create New</a> -->
                            </li>
                        </ol>
                    </nav>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="bgloading" v-show="Loading"><Loader></Loader></div>
            <div class="card-header">
              <div class="row">
                <div class="col-md-9">
                  <router-link :to="{name : 'WriteaCheckNew'}" class="btn btn-success">
                    <i class="fas fa-plus"></i> Add a Check
                  </router-link>
                </div>
                <div class="col-md-3">
                 <div style="position:relative; width:120px;display:block;">
                   <div style="display:block;position:relative">Vendors: <span style="background:#9eced6; width:10px; height:10px;position: absolute;right: 0; top: 5px;display:block;"></span></div>
                   <div style="display:block;position:relative">SubContractors: <span style="background:#f3dc99; width:10px; height:10px;position: absolute;right: 0; top: 5px;display:block;"></span></div>
                 </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <Loader v-if="isLoading"></Loader>
                <div v-else>
                  <table class="table table-striped" v-if="CheckList.length > 0">
                    <thead>
                      <tr>
                        <th scope="col">ID #</th>
                        <th scope="col">Exp. ID</th>
                        <th scope="col">Bank</th>
                        <th scope="col">Link</th>
                        <th scope="col">Check Date</th>
                        <th scope="col">Check #</th>
                        <th scope="col">Pay to</th>
                        <th scope="col">Memo</th>
                        <th scope="col">Amount</th>
                        <th scope="col" style="text-align:center;">Status</th>
                        <th scope="col"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in CheckList" :key="item.id" :class="[(item.type === 1) ? 'table-info' : 'table-warning']">
                        <th scope="row">
                          {{item.idx.toString().padStart(4,"000")}}
                        </th>
                        <td>
                          <span v-if="item.numdoc > 0">{{item.numdoc.toString().padStart(4,"000")}}</span>
                        </td>
                        <td>{{item.bankname}} {{item.banknumber}} </td>
                        <td>
                          <div v-if="item.status == 3">
                            <button title="Link to Bank" class="btn btn-danger btn-xs" v-if="item.link == 0" @click="modalTransac(item.id, item.bank_id)">
                              <i class="fas fa-unlink"></i>
                            </button>
                            <button title="Edit Linkage" class="btn btn-success btn-xs" v-else @click="modalEditTransac(item.id, item.bank_id, item.transac_id, item.transac_text)">
                              <i class="fas fa-link"></i>
                            </button>
                          </div>
                          <div v-else>
                            <button title="Link to Bank" class="btn btn-light btn-xs">
                              <i class="fas fa-unlink"></i>
                            </button>
                          </div>
                        </td>
                        <td>{{item.check_date}}</td>
                        <td>{{item.check_number}}</td>
                        <td>{{item.pay_to}}</td>
                        <td>{{item.memo}}</td>
                        <td>${{item.amount | formatMoney}}</td>
                        <td style="text-align:center;">
                         <span style="color:#fff;background-color:#ff7500;" class="badge badge-warning" v-if="item.status==1">Created</span>
                         <span class="badge badge-info" v-if="item.status==2" @click="convertToExp(item.id)">Printed</span>
                         <span class="badge badge-success" v-if="item.status==3">Expense</span>
                         <span class="badge badge-danger" v-if="item.status==4">Void</span>
                        </td>
                        <td style="width:85px">
                          <span class="cdropdown">
                            <button>Actions</button>
                            <label>
                              <input type="checkbox">
                              <ul>
                                <li @click="actionEdit(item.id)"><button><i class="fas fa-edit"></i> Edit</button></li>
                                <li @click="convertToExp(item.id)" v-if="item.status == 2"><button><i class="far fa-file-alt"></i> Convert To Expenses</button> </li>
                                <li @click="actionPdf(item.id)"><button><i class="fas fa-file-pdf"></i> Open PDF</button></li>
                                <li @click="validPrinted(item.id,item.idx)" v-if="item.status != 4"><button><i class="fas fa-print"></i> ePrint</button> </li>

                                <li v-if="item.status == 2 || item.status == 3" @click="anularPago(item.id, item.expense_id)">
                                  <button><i class="fas fa-trash-alt"></i> Void</button>
                                </li>
                                <li v-if="item.status == 1" @click="elimPago(item.id)">
                                  <button><i class="fas fa-times"></i> Delete</button>
                                </li>
                              </ul>
                            </label>
                          </span>
                        </td>
                      </tr>  
                    </tbody>
                  </table>
                  <div class="text-center d-block w-100 p20" v-else>
                    <div class="text-center" style="padding:30px;"> 
                      <div class="text-center" style="padding:30px;"> 
                        <span >It's time to create your first Check!</span><br>
                        <router-link :to="{name : 'WriteaCheckNew'}" class="btn btn-success " style="margin-top:7px">
                          Create New Check
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal name="New-item" width="60%" height="400px" @before-close="limpiarModal" :draggable="move">
      <div class="card">
        <div class="card-header">
          {{ modal.title }} 
          <button type="button" @click="hideModal" class="closeIcon"><span></span></button>
        </div>
        <div class="card-body" style="padding-bottom:100px;">
          <div class="alert alert-danger" v-if="modalError">{{ modalErrorMjs }}</div>
          <Loader v-if="modal.isLoading"></Loader>
          <div v-if="modal.bankingTransac">
            <div class="row">
              <div class="col-12">
                <div class="form-inline" style="flex-wrap: nowrap;">
                  <div class="form-group mb-2">
                    <select class="form-control" v-model="SelectOne">
                      <option value="1">This Year</option>
                      <option value="2">Last Year</option>
                      <option value="3">This Month</option>
                      <option value="4">Calendar</option>
                    </select>
                  </div>
                  <div class="form-group mb-2" v-if="SelectOne == 4">
                    <div style="display:flex;align-items: center;">
                      <span style="padding-right:4px;padding-left:8px;"><b>From:</b></span>
                      <span class="inputDateFilter">
                        <datetime type='date' v-model="dateFrom" format="MMM dd, yyyy" input-class="form-control"></datetime>
                      </span>
                      <span style="padding-right:4px;padding-left:8px;"><b>To:</b></span>
                      <span class="inputDateFilter">
                        <datetime type='date' v-model="dateTo" format="MMM dd, yyyy" input-class="form-control"></datetime>
                      </span>
                    </div>
                  </div>
                  <button type="button" class="btn btn-success mb-2" @click="filtros()" style="margin-left:10px;">
                    <i class="fas fa-search"></i> Filter
                  </button>
                </div>
              </div>
            </div>
            <div class="table-Transaction" >
              <model-select 
                :options="listTransaction" 
                v-model="transac_id" 
                placeholder="Choose a Bank Transaction">
              </model-select>
              <!-- <table class="table table-striped table-bordered table-hover">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Description</th>
                    <th>Amount</th>
                    <th>Type</th>
                    <th style="text-align:center;"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="listTransactionLoading">
                    <td colspan="7" style="text-align:center;"><Loader></Loader></td>
                  </tr>
                  <tr  v-for="i in listTransaction" v-else-if="listTransaction.length>0">
                    <td>{{ i.fecha }}</td>
                    <td>{{ i.description }}</td>
                    <td style="text-align: right">
                      <span class="text-danger" v-if="i.textRed==1">${{ i.amount | formatMoney }}</span>
                      <span v-else>${{ i.amount | formatMoney }}</span>
                    </td>
                    <td style="text-align:center;">
                      <div v-if="i.textRed==1">
                        <span class="badge badge-danger" v-if="i.acctrans==0" style="background-color:#ff7500;">
                          Unaccepted
                        </span>
                      </div>
                      <div v-else-if="i.amount == 0">
                        <span class="badge badge-light">Uncategorized</span>
                      </div>
                      <div v-else>
                        <span class="badge badge-success">{{ i.account }}</span>
                      </div>
                    </td>
                    <td style="text-align:center;">
                      <input type="radio"  v-model="transac_id" :value="i.id" >
                    </td>
                  </tr>
                  <tr v-else>
                    <td colspan="5" style="text-align:center;">No record</td>
                  </tr>
                </tbody>
              </table> -->
            </div>
            <div class="row" >
              <div class="col-12 text-right" style="padding-top:20px;">
                <button type="button" class="btn btn-success btn-xs" @click="SelectTransacID">
                  <i class="fas fa-check"></i> SELECT BANK TRANSACTION
                </button>
                <button type="button" class="btn btn-secundary btn-xs" style="margin-left: 10px;" @click="resetTransacID">
                  <i class="fas fa-times"></i> CANCEL
                </button>
                <button type="button" class="btn btn-danger btn-xs" style="margin-left: 10px;" @click="unlinkTransacID" v-if="unlink">
                  <i class="fas fa-unlink"></i> UNLINK
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal>
    <notifications group="noti" position="top center"></notifications>
  </billing-layout>
</template>
<script>
  import axios from 'axios'
  import Loader from '@/components/shared/Loader'
  import BillingLayout from '@/Layouts/Billing/BillingLayout'
  import EventBus from '@/eventBus'
  import ClickOutside from 'vue-click-outside';
  import { ModelSelect } from 'vue-search-select'
  export default {
    name:'WriteaCheck',
    components:{
      Loader,
      BillingLayout,
      ModelSelect
    },
    data() {
      return{
        isLoading : false,
        Loading : false,
        CheckList : [],
        modal:{
          title: '',
          bankingTransac: false,
          isLoading: false,
        },
        move: true,
        modalError: false,
        modalErrorMjs: '',
        transac_id: 0,
        SelectOne : 2,
        dateFrom : new Date((new Date().toISOString()+'').slice(0,10)+'T23:31:04.000Z').toISOString(),
        dateTo : new Date((new Date().toISOString()+'').slice(0,10)+'T23:31:04.000Z').toISOString(),
        listTransactionLoading: false,
        listTransaction: [],
        columna: 'col-sm-6',
        columna2: 'col-6 text-right',
        Banking_id: 0,
        checkITEM: 0,
        unlink: false,
        TransacSelected: '',
        send_print: 0,
      } 
    },
    created(){
      this.getlist();
      this.getEprint();
    },
    mounted(){

    },
    directives: {
      ClickOutside
    },
    methods:{
        getEprint(){
          var self = this;
          this.isLoading = true;
          window.billing.get('writecheck/valideprint/'+ window.localuserdata)
          .then((response) => {
            this.send_print=response.data.result;
          }).catch((error) => console.log(error));
        },
        limpiarModal(){
          this.modal.title='';
          this.modal.bankingTransac=false;
          this.modalError=false;
          this.modalErrorMjs='';
          this.SelectOne = 2;
          this.dateFrom = new Date((new Date().toISOString()+'').slice(0,10)+'T23:31:04.000Z').toISOString();
          this.dateTo = new Date((new Date().toISOString()+'').slice(0,10)+'T23:31:04.000Z').toISOString();
          this.Banking_id=0;
          this.checkITEM=0;
          this.unlink= false;
          this.TransacSelected='';
        },
        hideModal(){
          this.$modal.hide('New-item');
          this.limpiarModal();
        },
        modalEditTransac(item, bank_id, transac_id, transac_text){
          this.transac_id= transac_id;
          console.log('transac_id='+transac_id);
          this.checkITEM= item;
          this.Banking_id= bank_id;
          this.modal.title='SELECT BANK TRANSACTION';
          this.$modal.show('New-item');
          this.unlink= true;
          this.TransacSelected=transac_text;
          this.filtros();
        },
        modalTransac(item, bank_id){
          this.checkITEM= item;
          this.Banking_id= bank_id;
          this.modal.title='SELECT BANK TRANSACTION';
          this.$modal.show('New-item');
          this.filtros();
        },
        filtros(){
          let datos = {
            id: this.Banking_id,
            filter: this.SelectOne,
            status: [3],
            dateFrom: this.dateFrom,
            dateTo: this.dateTo,
          };
          this.modal.bankingTransac=false;
          this.listTransactions(datos);
        },
        listTransactions(datos){
          this.modal.isLoading = true;
          this.listTransactionLoading = true;
          this.listTransaction = [];
          window.billing.post('banking/transac', datos)
          .then((response) => {
            let transacList = response.data.result;
            for (let i in transacList) 
            {
              // solo transac en status unaccepted y no vinculados con expense
              if (transacList[i].type ==2 && transacList[i].acctrans==0  && transacList[i].expense_id==0) 
              {
                //this.listTransaction.push(transacList[i]);
                let text = transacList[i].fecha +' | ';
                text += transacList[i].description +' | ';
                text += transacList[i].amount +' | '; //formatMoney
                text += ' Unaccepted ';
                this.listTransaction.push({
                  value: transacList[i].id,
                  text: text,
                });
              }
            }
            if(this.unlink){
              this.listTransaction.push({
                  value: this.transac_id,
                  text: this.TransacSelected,
                });
            }
            this.modal.bankingTransac=true;
            this.listTransactionLoading = false;
            this.modal.isLoading = false;
          })
          .catch((error) => {
            this.listTransactionLoading = false;
            this.modal.isLoading = false;
            console.log(error);
          });
        },      
        resetTransacID(){
          this.transac_id=0;
          this.checkITEM=0;
          this.hideModal();
        },
        SelectTransacID(){
          if(this.transac_id==0 || this.checkITEM==0)
          {
            this.modalError=true;
            this.modalErrorMjs='Error, you must select a Transaction.';
          }
          else
          {
            console.log('item = '+this.checkITEM);
            console.log('transac_id = '+this.transac_id);
            this.isLoading = true;
            window.billing.post('vinculartransac', 
              { 
                id: this.checkITEM,
                transac_id : this.transac_id
              }
            ).then((response) => {
              console.log(response.data);
              this.hideModal();
              if(response.data.status){               
                    this.$notify({
                    group: 'noti',
                    title: 'Check',
                    type: 'success',
                    text: 'Complete Linkage.'
                  });
              }
              this.getlist();
             }).catch((error) => {
                this.isLoading = false;
                console.log(error);
            });
            
          }
        },        
        unlinkTransacID(){
          if(this.transac_id==0 || this.checkITEM==0)
          {
            this.modalError=true;
            this.modalErrorMjs='Error, you must select a Transaction.';
          }
          else
          {
            console.log('item = '+this.checkITEM);
            console.log('transac_id = '+this.transac_id);
            this.isLoading = true;
            window.billing.post('desvinculartransac', 
              { 
                id: this.checkITEM,
                transac_id : this.transac_id
              }
            ).then((response) => {
              console.log(response.data);
              this.hideModal();
              if(response.data.status){               
                    this.$notify({
                    group: 'noti',
                    title: 'Success',
                    type: 'success',
                  });
              }
              this.getlist();
             }).catch((error) => {
                this.isLoading = false;
                console.log(error);
            });
            
          }
        },
        convertToExp(id){
          this.isLoading = true;
          this.$swal({
            title: "Convert to Expense this Check?",
            text: "Are you sure?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Yes, convert!"
          }).then((result) => {
            if (result.value)
            {
              window.billing.post('writecheck/converttoexpense', {
                user_id: window.localuserdata,
                id: id,
              })
              .then((response) => {
                console.log(response.data);
                this.isLoading = false;
                if(response.data.status){
                  this.getlist();
                   this.$notify({
                      group: 'noti',
                      title: 'Convert to Expense!',
                      type: 'success',
                      text: 'Successful'
                    });
                  
                }
              }).catch((error) => {
                this.isLoading = false;
                console.log(error);
              });
            }
          });
          this.isLoading = false;
        },
        validPrinted(id,idx){
          if(this.send_print==1)
          {
            this.actionPrint(id,idx);
          }
          else
          {
            this.$swal({
              title: "You don't have Eprint configured, you want to convert check to printed anyway?",
              text: "Are you sure?",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Yes, change to printed!"
            }).then((result) => {
              if (result.value)
              {
                this.send_print=0;
                this.actionPrint();
              }
            });
          }
        },
        actionPrint(id,idx){
          let numdoc = idx.toString().padStart(4,"000");
          this.Loading = true
           window.billing.post('printcheck', 
              {
                user_id: window.localuserdata, 
                id: id,
                numdoc : numdoc,
                send_print: this.send_print,
              }
            ).then((response) => {
              this.Loading = false
              console.log(response.data);
              if(response.data.status){               
                    this.$notify({
                    group: 'noti',
                    title: 'Check',
                    type: 'success',
                    text: 'Successfully printed'
                  });
                  this.getlist();
              }else{
                this.$notify({
                    group: 'noti',
                    title: 'Check',
                    type: 'error',
                    text: 'Error printed'
                  });
        
              }
             }).catch((error) => {
                this.Loading = false;
                console.log(error);
                this.$notify({
                    group: 'noti',
                    title: 'Check',
                    type: 'error',
                    text: 'Error printed'
                  });
            });
        },
        actionPdf(id){
            window.open(urlbase + "api/v2/writeacheck/pdf/" + id , "_blank");
        },
      getlist(){
        this.isLoading = true;
        window.billing.get('writecheck/' + window.localuserdata)
        .then((response) => {
          console.log(response.data);
          this.CheckList = response.data.result;
  				this.isLoading = false;
        }).catch((error) => {           
          this.isLoading = false;
          console.log(error);
        });
      },
      actionEdit(id){
        this.$router.push({name:'WriteaCheckNew', params:{idw:id}});
      },        
      anularPago(id, edi)
      {
        this.isLoading = true;
        this.$swal({
          title: "Void this Check?",
          text: "Are you sure?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Yes, Void it!"
        }).then((result) => {
          if (result.value)
          {
            window.billing.post('writecheck/anular', {
              id: id,
              expense_id: edi
            })
            .then((response) => {
              console.log(response.data);
              this.isLoading = false;
              if(response.data.status){
                this.getlist();
                 this.$notify({
                    group: 'noti',
                    title: 'Void!',
                    type: 'success',
                    text: 'Void Check Successful'
                  });
                
              }
            }).catch((error) => {
              this.isLoading = false;
              console.log(error);
            });
          }
        });
        this.isLoading = false;   
      },     
      elimPago(id)
      {
        this.isLoading = true;
        this.$swal({
          title: "Delete this Check?",
          text: "Are you sure?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Yes, Delete it!"
        }).then((result) => {
          if (result.value)
          {
            window.billing.post('writecheck/del', {
              id: id,
            })
            .then((response) => {
              console.log(response.data);
              this.isLoading = false;
              if(response.data.status){
                this.getlist();
                this.$notify({
                    group: 'noti',
                    title: 'Delete!',
                    type: 'success',
                    text: 'Delete Check Successful'
                  });
                
              }
            }).catch((error) => {
              this.isLoading = false;
              console.log(error);
            });
          }
        });
        this.isLoading = false   
      },
    },
    watch:{

      dateFrom: function(){
        this.dateFrom= new Date((new Date(this.dateFrom).toISOString()+'').slice(0,10)+'T23:31:04.000Z').toISOString()
      },
      dateTo: function(){
        this.dateTo= new Date((new Date(this.dateTo).toISOString()+'').slice(0,10)+'T23:31:04.000Z').toISOString()
      },
      SelectOne: function(i){
        if(i > 3)
        {
          this.columna='col-sm-12';
          this.columna2='col-12 text-right';
        }
        else
        {
          this.columna='col-sm-6';
          this.columna2='col-6 text-right';
        }
      },
    }

  };
</script>
<style scope="sass">

</style>
